/* eslint-disable */
import { contactsImage } from './images'

export const theLightTheme = {
    type: 'light',
    primary: '#2563EB',
    quaternary: '#F4F7FF',
    quaternaryLight: '#DDE5F5',
    secondary: '#FFFFFF',
    tertiary: '#0F172A',
    buttonColor: '#1E293B',
    contactsimg: contactsImage
}

export const theDarkTheme = {
    type: 'dark',
    primary: '#60A5FA',
    secondary: '#090B10',
    quaternary: '#121622',
    quaternaryLight: '#95A3BE',
    tertiary: '#E7ECF7',
    buttonColor: '#1E2638',
    contactsimg: contactsImage
}
